export const PAGE_TITLE = 'Tiered Interventions Units'
export const BACK_LINK_ELEMENTARY = 'Elementary School Lessons'
export const BACK_LINK_MIDDLE = 'Middle School Lessons'
export const TIER_LABEL = 'TIER 2'
export const SHUTTER_LIST_CLASS_NAME = 'tiered-intervention-shutter-list'
